import React, { Fragment, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Fab from "@material-ui/core/Fab";
import SearchIcon from "@material-ui/icons/Search";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Box from "@material-ui/core/Box";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import Divider from "@material-ui/core/Divider";
import HotelsGoogleMap from "./Hotels/HotelsGoogleMap";
import Link from "@material-ui/core/Link";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Slider from "@material-ui/core/Slider";
import { ThemeProvider } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
// import Switch from "@material-ui/core/Switch";
import Chip from "@material-ui/core/Chip";
import TagFacesIcon from "@material-ui/icons/TagFaces";
import Paper from "@material-ui/core/Paper";

const muiTheme = createMuiTheme({
  overrides: {
    MuiSlider: {
      thumb: {
        color: "#FE5215",
      },
      track: {
        color: "#FE5215",
      },
      /*  rail: {
         color: 'black'
       } */
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    backgroundColor: "rgb(241 238 238)",
    marginBottom: 6,
    borderStyle: "solid",
    borderColor: "#949494",
    borderWidth: "thin",
  },
  rootChip: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  CardHeader: {
    color: "#016AA2",
  },
  separador: {
    marginBottom: 15,
    marginTop: 20,
  },
  form: {
    paddingTop: "0%",
  },
  TituloFiltroG: {
    color: "#FF5400",
    paddingBottom: 7,
    fontFamily: "MontserratSemiBold",
  },
  TituloFiltro: {
    color: "#016AA2",
    paddingBottom: 7,
    fontFamily: "MontserratSemiBold",
  },

  TituloNombre: {
    color: "#016AA2",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  CardContent: {
    paddingLeft: 8,
    paddingTop: 8,
    paddingBottom: 0,
  },
  Checkbox: {
    paddingTop: 3,
    paddingBottom: 3,
  },
  extendedIcon: {
    // marginRight: theme.spacing(1),
  },
  buttonFilter: {
    background: "#FE5215",
    color: "white",
    fontFamily: "MontserratSemiBold",
    textTransform: "capitalize",
    "&:hover": {
      background: "#016AA2",
      color: "white",
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
  textField: {
    width: "70px",
    marginRight: "5px",
  },
  InputProps: {
    fontSize: "12px",
    paddingLeft: "3px",
    paddingRight: "3px",
    textAlign: "right",
  },
  InputPropsName: {
    fontSize: "12px",
    paddingLeft: "3px",
    paddingRight: "3px",
  },
  LabelCheck: {
    marginRight: "7px",
    marginBottom: "3px",
  },
  inputLabel: {
    /* "&.focused": {
      color: 'red'
    }, */
    fontSize: "12px",
    "&.shrink": {
      // backgroundColor: "grey",
      fontSize: "16px",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CardFilter(props, token) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [destacadosState, setDestacadosState] = React.useState(false);
  const [flagPrice, setFlagPrice] = React.useState(false);
  // const [flagReset, setFlagReset] = React.useState(props.flagFilter);
  /*   const [precioDesde, setPrecioDesde] = React.useState(props.precioDesde)
    const [precioHasta, setPrecioHasta] = React.useState(props.precioHasta) */
  const [chipData, setChipData] = React.useState([]);
  const [filltersCat, setfilltersCat] = React.useState({
    cat6: false,
    cat5: false,
    cat4: false,
    cat3: false,
    cat2: false,
    cat1: false,
  });
  const [filltersReg, setfilltersReg] = React.useState({
    SA: false,
    AD: false,
    MP: false,
    PC: false,
    TI: false,
  });
  const [hotel, setHotel] = React.useState("");
  const [valueSlider, setValueSlider] = React.useState([
    props.precioDesde,
    props.precioHasta,
  ]);

  useEffect(() => {
    setValueSlider([props.precioDesde, props.precioHasta]);
  }, [props.precioDesde]);

  useEffect(() => {
    setValueSlider([props.precioDesde, props.precioHasta]);
  }, [props.precioHasta]);

  useEffect(() => {
    if (props.flagFilter) {
      ResetFilter();
    }
  }, [props.flagFilter]);

  const handleChange = (name) => (event) => {
    setfilltersCat({ ...filltersCat, [name]: event.target.checked });

    var filtC = { ...filltersCat, [name]: event.target.checked };
    if (
      filtC.cat1 === false &&
      filtC.cat2 === false &&
      filtC.cat3 === false &&
      filtC.cat4 === false &&
      filtC.cat5 === false &&
      filtC.cat6 === false
    ) {
      DeleteChip({ key: 0, label: "Clasificación" });
    } else {
      addchipData({ key: 0, label: "Clasificación" });
    }
    FilterCat(filtC);
  };

  function FilterCat(fCat) {
    var ClearFiltro = false;
    props.onClick(
      fCat,
      hotel,
      props.token,
      "1",
      [0, 0],
      filltersReg,
      ClearFiltro,
      destacadosState
    );
  }

  function addchipData(chipToAdd) {
    var pp = chipData;
    if (chipData.filter((chip) => chip.key === chipToAdd.key).length === 0) {
      pp.push(chipToAdd);
    }
    setChipData(pp);
  }

  const handleDelete = (chipToDelete) => () => {
    DeleteChip(chipToDelete);
  };

  function DeleteChip(chipToDelete) {
    switch (chipToDelete.label) {
      case "Clasificación":
        var fCat = {
          cat6: false,
          cat5: false,
          cat4: false,
          cat3: false,
          cat2: false,
          cat1: false,
        };
        setfilltersCat(fCat);
        FilterCat(fCat);
        break;
      case "Régimen":
        var fReg = {
          SA: false,
          AD: false,
          MP: false,
          PC: false,
          TI: false,
        };
        setfilltersReg(fReg);
        FilterReg(fReg);
        break;
      case "Precios":
        setFlagPrice(false);
        var ClearFiltro = false;
        props.onClick(
          filltersCat,
          hotel,
          props.token,
          "1",
          [0, 0],
          filltersReg,
          ClearFiltro,
          destacadosState
        );
        break;
      case "Nombre":
        setHotel("");

        props.onClick(
          filltersCat,
          "",
          props.token,
          "1",
          [0, 0],
          filltersReg,
          false,
          destacadosState
        );
        break;
      case "Destacados":
        setDestacadosState(false);
        filterDest(false);
        break;
      default:
    }
    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  }

  const handleChangeReg = (name) => (event) => {
    setfilltersReg({ ...filltersReg, [name]: event.target.checked });

    var filtR = { ...filltersReg, [name]: event.target.checked };
    if (
      filtR.SA === false &&
      filtR.AD === false &&
      filtR.MP === false &&
      filtR.PC === false &&
      filtR.TI === false
    ) {
      DeleteChip({ key: 1, label: "Régimen" });
    } else {
      addchipData({ key: 1, label: "Régimen" });
    }
    FilterReg(filtR);
  };

  function FilterReg(filtR) {
    var ClearFiltro = false;
    props.onClick(
      filltersCat,
      hotel,
      props.token,
      "1",
      [0, 0],
      filtR,
      ClearFiltro,
      destacadosState
    );
  }

  const handleChangeSlider = (event, newValue) => {
    if (newValue[0] != props.precioDesde || newValue[1] != props.precioHasta) {
      setFlagPrice(true);
    }
    setValueSlider(newValue);
    /*     setPrecioDesde(newValue[0])
        setPrecioHasta(newValue[1]) */
  };

  function valuetextSlider(valueSlider) {
    return `°C${valueSlider}`;
  }

  const handleHotel = (event) => {
    const value = event.target.value;
    setHotel(value);
  };

  const FilterGoogleMap = (hotelName) => {
    ClearFilter();
    var precios = [0, 0];
    var fCat = {
      cat6: false,
      cat5: false,
      cat4: false,
      cat3: false,
      cat2: false,
      cat1: false,
    };
    setfilltersCat(fCat);
    var fReg = {
      SA: false,
      AD: false,
      MP: false,
      PC: false,
      TI: false,
    };
    setfilltersReg(fReg);
    setFlagPrice(false);
    setDestacadosState(false);
    handleCloseDialog();
    setHotel(hotelName);
    var ClearFiltro = false;
    props.onClick(
      fCat,
      hotelName,
      props.token,
      "1",
      precios,
      fReg,
      ClearFiltro,
      false
    );
  };

  const AplyFilter = (e) => {
    var precios = [];
    if (!flagPrice) {
      precios = [0, 0];
    } else {
      precios = valueSlider;
      addchipData({ key: 3, label: "Precios" });
    }
    if (hotel !== "") {
      addchipData({ key: 4, label: "Nombre" });
    }
    if (ValidateHadFilter()) {
      var ClearFiltro = false;
      props.onClick(
        filltersCat,
        hotel,
        props.token,
        "1",
        precios,
        filltersReg,
        ClearFiltro,
        destacadosState
      );
    } else {
      ClearFilter();
    }
  };

  const ValidateHadFilter = (e) => {
    if (
      !filltersCat.cat1 &&
      !filltersCat.cat2 &&
      !filltersCat.cat3 &&
      !filltersCat.cat4 &&
      !filltersCat.cat5 &&
      !filltersCat.cat6 &&
      !filltersReg.SA &&
      !filltersReg.AD &&
      !filltersReg.MP &&
      !filltersReg.PC &&
      !filltersReg.TI &&
      hotel == "" &&
      !flagPrice &&
      !destacadosState
    ) {
      return false;
    } else {
      return true;
    }
  };

  const ClearFilter = (e) => {
    setChipData([]);
    var fCat = {
      cat6: false,
      cat5: false,
      cat4: false,
      cat3: false,
      cat2: false,
      cat1: false,
    };
    setfilltersCat(fCat);
    var fReg = {
      SA: false,
      AD: false,
      MP: false,
      PC: false,
      TI: false,
    };
    setfilltersReg(fReg);
    setHotel("");
    setFlagPrice(false);
    setDestacadosState(false);
    var ClearFiltro = true;
    var hot = "";
    props.onClick(fCat, hot, props.token, "1", [0, 0], fReg, ClearFiltro, 0);
  };

  const ResetFilter = (e) => {
    setfilltersCat({
      cat5: false,
      cat4: false,
      cat3: false,
      cat2: false,
      cat1: false,
    });
    setfilltersReg({
      SA: false,
      AD: false,
      MP: false,
      PC: false,
      TI: false,
    });
    setHotel("");
    setFlagPrice(false);
    setDestacadosState(false);
    setChipData([]);
    setValueSlider([0, 0]);
  };

  const handleClickOpenDialog = () => {
    /*   setPrecioDesde(props.precioDesde)
      setPrecioHasta(props.precioHasta) */
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleChangeDestacados = (event) => {
    setDestacadosState(event.target.checked);

    var dest = event.target.checked;
    if (dest === false) {
      DeleteChip({ key: 2, label: "Destacados" });
    } else {
      addchipData({ key: 2, label: "Destacados" });
    }
    filterDest(dest);
  };

  function filterDest(dest) {
    var precios = [];
    if (!flagPrice) {
      precios = [0, 0];
    } else {
      precios = valueSlider;
    }
    //  VALIDA LOS FILTROS PARA MOSTRAR O NO LA SECCION DE LOS HOTELES DESTACADOS
    /* var fC = {
      cat5: false,
      cat4: false,
      cat3: false,
      cat2: false,
      cat1: false,
    };
    var fR = {
      SA: false,
      AD: false,
      MP: false,
      PC: false,
      TI: false,
    };

     if (
      !flagPrice &&
      hotel == "" &&
      !dest &&
      filltersCat.cat1 == fC.cat1 &&
      filltersCat.cat2 == fC.cat2 &&
      filltersCat.cat3 == fC.cat3 &&
      filltersCat.cat4 == fC.cat4 &&
      filltersCat.cat5 == fC.cat5 &&
      filltersReg.cat1 == fR.cat1 &&
      filltersReg.cat2 == fR.cat2 &&
      filltersReg.cat3 == fR.cat3 &&
      filltersReg.cat4 == fR.cat4 &&
      filltersReg.cat5 == fR.cat5
    ) {
      ClearFilter();
    } else { */
    var clearF = false;
    props.onClick(
      filltersCat,
      hotel,
      props.token,
      "1",
      precios,
      filltersReg,
      clearF,
      dest
    );
    /*  }*/
  }

  const keyPressNombre = (e) => {
    if (e.key == "Enter") {
      e.preventDefault();
    }
  };

  const keyUpNombre = (e) => {
    /*     console.log(e.target.value);
    console.log(e.target.keyCode);
    console.log(e.target.charCode); */
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  };

  return (
    <Fragment>
      <Card className={classes.root}>
        <CardContent className={classes.CardContent} align="center">
          <Typography
            id="range-slider"
            variant="h6"
            className={classes.TituloFiltroG}
            align="center"
          >
            Criterio de Búsqueda
          </Typography>

          {props.zoneName.includes("Orlando") ? (
            <Fragment>
              <Divider variant="middle" className={classes.separador} />

              <Typography
                variant="body1"
                className={classes.TituloFiltro}
                align="center"
              >
                Clasificación de atracciones
              </Typography>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    // control={<Checkbox className={classes.Checkbox} value="cat5" onChange={handleChange('cat5')} value={filltersCat.cat5} />}
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat1")}
                        checked={filltersCat.cat1}
                        value={filltersCat.cat1}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={<Typography variant="body2">Disney</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat2")}
                        checked={filltersCat.cat2}
                        value={filltersCat.cat2}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={<Typography variant="body2" style={{ textAlign: "left", marginTop: "8px" }}>Universal</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat3")}
                        checked={filltersCat.cat3}
                        value={filltersCat.cat3}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={<Typography variant="body2" style={{ textAlign: "left", marginTop: "8px" }}>SeaWorld: Incluye Busch Gardens y  Aquatica *</Typography>}
                  />
{/*                   <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat4")}
                        checked={filltersCat.cat4}
                        value={filltersCat.cat4}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={
                      <Typography variant="body2">Busch Gardens</Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat5")}
                        checked={filltersCat.cat5}
                        value={filltersCat.cat5}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={<Typography variant="body2">Aquatica</Typography>}
                  /> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.Checkbox}
                        onChange={handleChange("cat6")}
                        checked={filltersCat.cat6}
                        value={filltersCat.cat6}
                        color="default"
                        checkedIcon={
                          <span
                            className={clsx(classes.icon, classes.checkedIcon)}
                          />
                        }
                        icon={<span className={classes.icon} />}
                      />
                    }
                    label={<Typography variant="body2" style={{ textAlign: "left", marginTop: "8px" }}>Otros</Typography>}
                  />
                </FormGroup>
              </FormControl>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}

          <Divider variant="middle" className={classes.separador} />

          <Typography
            id="range-slider"
            variant="body1"
            className={classes.TituloFiltro}
            align="center"
          >
            Rango de precio
          </Typography>
          <div style={{ width: "100%", marginTop: "10px" }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              spacing={3}
            >
              <Box>
                <TextField
                  label="Desde"
                  id="outlined-size-small"
                  InputProps={{
                    classes: {
                      root: classes.InputProps,
                      input: classes.InputProps,
                    },
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: "focused",
                      shrink: "shrink",
                    },
                  }}
                  value={valueSlider[0]}
                  /*   onChange={(event) => {
                      setPrecioDesde(event.target.value);
                      setValueSlider([event.target.value, precioHasta]);
                    }} */
                  className={classes.textField}
                  variant="outlined"
                  size="small"
                />
              </Box>
              <Box>
                <TextField
                  className={classes.textField}
                  label="Hasta"
                  InputProps={{
                    classes: {
                      root: classes.InputProps,
                      input: classes.InputProps,
                    },
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.inputLabel,
                      focused: "focused",
                      shrink: "shrink",
                    },
                  }}
                  id="outlined-size-small2"
                  value={valueSlider[1]}
                  /* onChange={(event) => {
                    setPrecioHasta(event.target.value);
                    setValueSlider([precioDesde, event.target.value]);
                  }} */
                  variant="outlined"
                  size="small"
                />
              </Box>
            </Box>
            <div>
              <ThemeProvider theme={muiTheme}>
                <Slider
                  value={valueSlider}
                  onChange={handleChangeSlider}
                  valueLabelDisplay="off"
                  aria-labelledby="range-slider"
                  getAriaValueText={valuetextSlider}
                  min={props.precioDesde}
                  max={props.precioHasta}
                />
              </ThemeProvider>
            </div>
            {flagPrice ? (
              <div style={{ width: "100%" }}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  component="span"
                  flexDirection="column"
                  m={0}
                >
                  <Box m={0} mb={1}>
                    <Fab
                      size="small"
                      color="primary"
                      variant="extended"
                      onClick={AplyFilter}
                      className={classes.buttonFilter}
                    >
                      <SearchIcon className={classes.extendedIcon} /> Filtrar
                      precio
                    </Fab>
                  </Box>
                </Box>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <Divider variant="middle" className={classes.separador} />
          <Typography
            variant="body1"
            className={classes.TituloFiltro}
            align="center"
          >
            Nombre de servicio
          </Typography>
          <form className={classes.form} noValidate autoComplete="off">
            <TextField
              InputProps={{
                classes: {
                  root: classes.InputPropsName,
                  input: classes.InputPropsName,
                },
              }}
              id="standard-basic"
              variant="outlined"
              name="hotel"
              onChange={handleHotel}
              size="small"
              value={hotel}
              onKeyPress={keyPressNombre}
              onKeyUp={keyUpNombre}
            />
          </form>
          {hotel ? (
            <div style={{ width: "100%" }}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                component="span"
                flexDirection="column"
                m={0}
              >
                <Box m={0} mt={1}>
                  <Fab
                    size="small"
                    color="primary"
                    variant="extended"
                    onClick={AplyFilter}
                    className={classes.buttonFilter}
                  >
                    <SearchIcon className={classes.extendedIcon} /> Filtrar
                    nombre
                  </Fab>
                </Box>
              </Box>
            </div>
          ) : (
            <div></div>
          )}
        </CardContent>
        <CardActions>
          <div style={{ width: "100%" }}>
            <Divider variant="middle" className={classes.separador} />
            {chipData.length > 0 ? (
              <Paper component="ul" className={classes.rootChip}>
                {chipData.map((data) => {
                  let icon;

                  if (data.label === "React") {
                    icon = <TagFacesIcon />;
                  }

                  return (
                    <li key={data.key}>
                      <Chip
                        size="small"
                        icon={icon}
                        label={data.label}
                        onDelete={
                          data.label === "React"
                            ? undefined
                            : handleDelete(data)
                        }
                        className={classes.chip}
                      />
                    </li>
                  );
                })}
              </Paper>
            ) : (
              <div></div>
            )}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              component="span"
              flexDirection="column"
              m={0}
            >
              {/*   <Box m={1}>
                <Fab
                  size="small"
                  color="primary"
                  variant="extended"
                  onClick={AplyFilter}
                  className={classes.buttonFilter}
                >
                  <SearchIcon className={classes.extendedIcon} /> Aplicar filtros
                </Fab>
              </Box> */}
              <Box m={1}>
                <Fab
                  size="small"
                  color="primary"
                  variant="extended"
                  onClick={ClearFilter}
                  className={classes.buttonFilter}
                >
                  <HighlightOffIcon className={classes.extendedIcon} /> Borrar
                  filtros
                </Fab>
              </Box>
            </Box>
          </div>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
      >
        <HotelsGoogleMap
          dataHotelsDetails={props.dataHotelsDetails}
          onClick={FilterGoogleMap}
          zoneName={props.zoneName}
          countryFlag={props.countryFlag}
          value={props.precioDesde}
        ></HotelsGoogleMap>
      </Dialog>
    </Fragment>
  );
}
